import { createFileRoute, Outlet } from "@tanstack/react-router";

const ClientsRouteComponent = () => {
  return <Outlet />;
};

export const Route = createFileRoute("/_auth/_frame/clients")({
  component: ClientsRouteComponent,
});
